





































































































































































































































































































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { ListModel } from "@/shared/models/listModel";
import { DataOptions } from "vuetify";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import { SortableTableHeader } from "@/components/generic-pms-table/SortableTableDirective";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import DateField from "@/components/misc/DateField.vue";
import NoData from "@/components/misc/NoData.vue";
import * as _ from "lodash";
import {
  FinancialDocumentStatusEnum,
  FinancialDocumentTypesEnum,
  TenantTypesEnum,
} from "@/shared/models/enums.type";
import { FinancialSettingsType } from "@/store/modules/financial";
import { AddOnServiceTranslation } from "@/shared/models/addOnService";
import { ServiceType } from "@/shared/models/serviceType";
import { FinancialDocumentType } from "@/shared/models/financialDocumentType";
import { TaxRateView } from "@/shared/models/taxRates";
import { BusinessUnit } from "@/shared/models/businessUnit";
import { VFinancialDocument } from "@/shared/models/VFinancialDocument";
import { MultipleDocumentsInvoicingViewModel } from "@/components/finances/MultipleDocumentsInvoice/types";
import LoadingOverlay from "@/components/misc/LoadingOverlay.vue";
import { JwtClaims } from "@/store/modules/auth";
import { FinDocLineItemViewModel } from "../FinancialDocumentFormParts/models";

@Component({
  components: {
    SortableHeadersTable,
    DateField,
    LoadingOverlay,
    NoData,
  },
})
export default class MultipleDocumentsInvoice extends Vue {
  loading = true;
  loadingMultipleDocuments = false;

  @PropSync("open", { default: false }) internalOpen?: boolean;

  @Prop({ default: () => [] }) servicePeriod?: string[];
  @Prop() clientName?: string;
  @Prop({ default: () => [] }) existingLineItems?: FinDocLineItemViewModel[];

  // prettier-ignore
  @Action("codebooks/refreshFinancialDocumentTypes")
  refreshDocumentTypes?: () => Promise<void>;
  @Getter("codebooks/financialDocumentTypes")
  financialDocumentTypes?: FinancialDocumentType[];

  // prettier-ignore
  @Action("codebooks/refreshTaxRates")refreshTaxRates?: () => Promise<void>;
  @Getter("codebooks/taxRates") taxRates?: TaxRateView[];

  // prettier-ignore
  @Getter("financial/settings") storedSettings?: FinancialSettingsType;
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;

  @Getter("businessUnit/activeBusinessUnit") activeBusinessUnit?: BusinessUnit;
  @Getter("language/language") language?: string;

  @Action("codebooks/refreshServiceTypes")
  refreshServiceTypes?: () => Promise<void>;
  @Getter("codebooks/serviceTypes")
  serviceTypes?: ServiceType[];

  @Getter("appParams/tenantGeneratesDeliveryNotes")
  tenantGeneratesDeliveryNotes?: boolean;

  @Getter("appParams/cashRegisterFeatureFlag")
  cashRegisterFeature?: boolean;

  @Getter("appParams/typeId") tenantTypeId?: number;

  async created() {
    const promises = [];

    if (
      (this.financialDocumentTypes?.length ?? 0) === 0 &&
      this.refreshDocumentTypes
    ) {
      promises.push(this.refreshDocumentTypes());
    }

    if ((this.taxRates?.length ?? 0) === 0 && this.refreshTaxRates) {
      promises.push(this.refreshTaxRates());
    }

    if (this.refreshSettings) {
      promises.push(this.refreshSettings());
    }

    await Promise.all(promises);
  }

  settingsOpen = false;

  headers: SortableTableHeader[] = [];

  @Getter("auth/claims") claims?: JwtClaims;
  @Watch("claims.roles", { immediate: true })
  rolesWatch() {
    this.headers = [
      {
        text: "VFinancialDocument.issueDate",
        value: "issueDate",
        active: true,
        default: false,
        class: "resize-header issuedate-header",
        exportHeaders: [],
      },
      {
        text: "VFinancialDocument.documentType",
        value: "documentType",
        active: true,
        default: false,
        class: "resize-header doctype-header",
        exportHeaders: ["documentTypeTextResourceKey"],
      },
      {
        text: "VFinancialDocument.status",
        value: "status",
        active: true,
        default: false,
        class: "resize-header status-header",
        exportHeaders: ["statusTextResourceKey"],
      },
      ...(this.cashRegisterFeature
        ? [
            {
              text: "VFinancialDocument.documentIdentifier",
              value: "documentIdentifier",
              active: true,
              default: false,
              class: "resize-header docnum-header",
              exportHeaders: [],
            },
            {
              text: "VFinancialDocument.documentInternalIdentifier",
              value: "documentInternalIdentifier",
              active: true,
              default: false,
              class: "resize-header docnum-header",
              exportHeaders: [],
            },
          ]
        : [
            {
              text: "VFinancialDocument.documentNumberComplete",
              value: "documentNumberComplete",
              active: true,
              default: false,
              class: "resize-header docnum-header",
              exportHeaders: [],
            },
          ]),
      {
        text: "VFinancialDocument.customerName",
        value: "customerName",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "VFinancialDocument.totalDueAmount",
        value: "totalDueAmount",
        active: true,
        default: false,
        class: "resize-header totaldue-header",
        exportHeaders: [],
      },
      {
        text: "VFinancialDocument.totalWithVat",
        value: "totalWithVat",
        active: false,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "VFinancialDocument.vat",
        value: "vat",
        active: false,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "VFinancialDocument.totalWithoutVat",
        value: "totalWithoutVat",
        active: false,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "VFinancialDocument.paymentMeans",
        value: "paymentMeans",
        active: false,
        default: false,
        class: "resize-header",
        exportHeaders: ["paymentMeansTextResourceKey"],
      },
      {
        text: "VFinancialDocument.cardType",
        value: "cardType",
        active: false,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "VFinancialDocument.isFiscalized",
        value: "isFiscalized",
        active: false,
        default: false,
        class: "resize-header header-filter",
        exportHeaders: [],
      },
      ...(this.cashRegisterFeature
        ? [
            {
              text: "VFinancialDocument.referenceDocumentIdentifier",
              value: "referenceDocumentIdentifier",
              active: false,
              default: false,
              class: "resize-header",
              exportHeaders: [],
            },
            {
              text: "VFinancialDocument.referenceDocumentInternalIdentifier",
              value: "referenceDocumentInternalIdentifier",
              active: false,
              default: false,
              class: "resize-header",
              exportHeaders: [],
            },
          ]
        : [
            {
              text: "VFinancialDocument.referenceDocument",
              value: "referenceDocument",
              active: false,
              default: false,
              class: "resize-header",
              exportHeaders: [],
            },
          ]),
      {
        text: "VFinancialDocument.propertyName",
        value: "propertyName",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "VFinancialDocument.dueDate",
        value: "dueDate",
        active: true,
        default: false,
        class: "resize-header duedate-header",
        exportHeaders: [],
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        active: true,
        default: true,
        class: "resize-header",
        exportHeaders: [],
      },
    ];
  }

  get issueDate() {
    const res = [
      this.filters.issueDateFromPeriod
        ? this.filters.issueDateFromPeriod.substring(0, 10) ?? ""
        : "",
      this.filters.issueDateToPeriod
        ? this.filters.issueDateToPeriod.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set issueDate(val: string[]) {
    if (val && _.isArray(val)) {
      this.filters.issueDateFromPeriod = val.length > 0 ? val[0] : "";
      this.filters.issueDateToPeriod = val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.filters.issueDateFromPeriod = "";
      this.filters.issueDateToPeriod = "";
    }
  }

  documentTypeIds = [] as number[];
  @Watch("documentTypeIds")
  watchDocumentTypes(val: any, old: any) {
    if (!_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  filters = {
    issueDateFromPeriod: "",
    issueDateToPeriod: "",
    dueDate: "",
    documentNumberComplete: "",
    documentIdentifier: "",
    documentInternalIdentifier: "",
    statusId: FinancialDocumentStatusEnum.Zakljucen,
    customerName: "",
    referenceDocument: "",
    propertyName: "",
    reservationId: null as number | null,
    excludedDocumentIds: "",
    excludeMultiDocumentInvoices: true,
    excludeContainedInLockedMultiDocInvoices: true,
  };

  @Watch("filters", { deep: true })
  watchFilters(val: any, old: any) {
    if (_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  @Watch("internalOpen")
  watchOpen(fresh: boolean) {
    if (fresh) {
      (this.documentTypeIds = this.tenantGeneratesDeliveryNotes
        ? [FinancialDocumentTypesEnum.Otpremnica as number]
        : []),
        (this.filters.customerName = this.clientName ?? "");
      if (this.servicePeriod && this.servicePeriod.length == 2) {
        this.filters.issueDateFromPeriod = this.servicePeriod[0];
        this.filters.issueDateToPeriod = this.servicePeriod[1];
      }
    }

    if (fresh && this.initLoaded) {
      this.options.page = 1;
      this.debouncedLoad();
    }

    if (!fresh) {
      this.selected = [];
      (this.filters.issueDateFromPeriod = ""),
        (this.filters.issueDateToPeriod = ""),
        (this.filters.dueDate = ""),
        (this.filters.documentNumberComplete = ""),
        (this.filters.documentIdentifier = ""),
        (this.filters.documentInternalIdentifier = ""),
        (this.filters.statusId = FinancialDocumentStatusEnum.Zakljucen);
      (this.filters.customerName = ""),
        (this.filters.referenceDocument = ""),
        (this.filters.propertyName = ""),
        (this.filters.reservationId = null as number | null),
        (this.filters.excludedDocumentIds = "");

      this.list = {
        result: [],
        count: 0,
      };
    }
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["financialDocumentId"],
    sortDesc: [true],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  initLoaded = false;
  @Watch("options", { deep: true })
  watchOptions(fresh: DataOptions, old: DataOptions) {
    if (!this.initLoaded || !_.isEqual(fresh, old)) {
      this.initLoaded = true;
      this.load();
    }
  }

  list: ListModel<VFinancialDocument> = {
    count: 0,
    result: [],
  };

  debouncedLoad = _.debounce(this.load, 500);

  firstLoad = true;
  initialListSize = 0;

  async load(): Promise<ListModel<VFinancialDocument>> {
    this.loading = true;
    return this.axios
      .get<ListModel<VFinancialDocument>>("/financialDocuments", {
        params: this.queryParams,
      })
      .then((res) => {
        this.list = res.data;
        if (this.firstLoad) {
          this.initialListSize = this.list.count ?? 0;
        }
        return this.list;
      })
      .finally(() => {
        this.firstLoad = false;
        this.loading = false;
      });
  }

  get queryParams() {
    const excludedDocs = this.existingLineItems
      ? this.existingLineItems
          .filter(
            (x) =>
              x.financialDocumentId !== null &&
              x.financialDocumentId !== undefined
          )
          .map((x) => x.financialDocumentId)
      : [];

    const values = excludedDocs ? [...new Set(excludedDocs)] : [];

    this.filters.excludedDocumentIds = values.join(",");

    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      ...this.filters,
      documentTypeIds: this.documentTypeIds.join(","),
    };
  }

  scrollToTop() {
    let scrollableWrapper: Element | null = null;

    if (this.$refs.dataTable instanceof Vue) {
      scrollableWrapper = (this.$refs.dataTable as Vue).$el.querySelector(
        ".v-data-table__wrapper"
      );
    } else if (this.$refs.dataTable instanceof Element) {
      scrollableWrapper = (this.$refs.dataTable as Element).querySelector(
        ".v-data-table__wrapper"
      );
    }

    if (scrollableWrapper) {
      scrollableWrapper.scrollTop = 0;
    }
  }

  //selection
  selected = [] as VFinancialDocument[];

  async addToInvoice() {
    this.loadingMultipleDocuments = true;
    if (!this.storedSettings && this.refreshSettings) {
      await this.refreshSettings();
    }

    await this.refreshAddOnServicesTranslations();

    const request = {
      financialDocumentIds: this.selected.map((x) => x.financialDocumentId),
    };

    this.axios
      .post<MultipleDocumentsInvoicingViewModel>(
        "/financialDocuments/GetMultipleDocumentsInvoicingData",
        request
      )
      .then(({ data }) => {
        this.$emit("mergeInvoices", data);
        this.loadingMultipleDocuments = false;
      });
  }

  addOnServicesTranslations: AddOnServiceTranslation[] = [];
  async refreshAddOnServicesTranslations() {
    await Vue.axios
      .get<ListModel<AddOnServiceTranslation>>("addOnServices/translations")
      .then((res) => {
        this.addOnServicesTranslations = res.data.result;
      });
  }

  selectingAll = false;
  selectAllInvoices(val: boolean) {
    this.selectingAll = true;
    this.axios
      .get<VFinancialDocument[]>(
        "/financialDocuments/GetAllInvoicesForMultipleInvoicing",
        {
          params: this.queryParams,
        }
      )
      .then((res) => {
        if (val) {
          this.selected = [...res.data];
        } else {
          this.selected = this.selected.filter(
            (item) =>
              !res.data.some(
                (x) => x.financialDocumentId === item.financialDocumentId
              )
          );
        }
      })
      .finally(() => {
        this.scrollToTop();
        this.selectingAll = false;
      });
  }

  //initialListSize will be the maximum size this table can be
  //so selected array should be compared only to that initial state
  //anything less that that can be considered as -> not all selected
  areAllInvoicesSelected() {
    return (
      this.selected.length === this.initialListSize &&
      (this.list.count ?? 0) > 0
    );
  }

  get isTenantTypeAgency(){
    return this.tenantTypeId === TenantTypesEnum.Agency;
  }

  get allowedFinancialDocumentTypes() {
    let types = _.cloneDeep(this.financialDocumentTypes);
  
    if (!this.isTenantTypeAgency) {
      types = types?.filter(
        document => document.id !== FinancialDocumentTypesEnum.VlasnikovRacun &&
                    document.id !== FinancialDocumentTypesEnum.RacunZaProviziju
      );
    } 
    if (!this.cashRegisterFeature) {
      types = types?.filter(
        document => document.id !== FinancialDocumentTypesEnum.Uplatnica &&
                    document.id !== FinancialDocumentTypesEnum.Isplatnica
      );
    }

    return types;
  }
}
